"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#F6E7F6",
  d: "M4 5h4v1h8V5h4.25v5.5L14.5 15l-.5 2 1.5.5 4.75-3.5v7H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CE3BCE",
  fillRule: "evenodd",
  d: "M7.977 2.25a.7.7 0 0 0-.7.7v.8h-3.6a.7.7 0 0 0-.7.7v16.6a.7.7 0 0 0 .7.7h16.6a.7.7 0 0 0 .7-.7v-3.5a.7.7 0 1 0-1.4 0v2.8h-15.2V5.15h2.9v.8a.7.7 0 0 0 .7.7h8a.7.7 0 0 0 .7-.7v-.8h2.9v1.9a.7.7 0 1 0 1.4 0v-2.6a.7.7 0 0 0-.7-.7h-3.6v-.8a.7.7 0 0 0-.7-.7zm7.3 1.4h-6.6v1.6h6.6zm-7.3 6.15a.7.7 0 0 0 0 1.4h5.5a.7.7 0 1 0 0-1.4zm0 3a.7.7 0 1 0 0 1.4h2.5a.7.7 0 1 0 0-1.4zm0 3a.7.7 0 1 0 0 1.4h2a.7.7 0 0 0 0-1.4zm12.069-6.465a.7.7 0 0 1 .982.12l1.847 2.364a.7.7 0 0 1-.12.983l-6.381 4.985a.7.7 0 0 1-.434.148l-2.423-.01a.7.7 0 0 1-.677-.867l.576-2.353a.7.7 0 0 1 .249-.385zm.31 1.534-5.638 4.405-.307 1.255 1.292.005 5.638-4.404z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FormsColorIcon24.js.map